

// All imports must be at the top
import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useParams } from "react-router-dom";
import { message } from "antd";
import "antd/dist/reset.css";
import Page1 from "./components/page1";
import HeaderComponent from "./components/header";
import FooterComponent from "./components/footer";
import "./css/crpHeader.css";





{/* hs-CRP Level Bar Section */ }
{
  (() => {
    // Example value, replace with real data as needed
    const crpValue = 3;
    // Make scale 0 to 10 as requested
    const min = 0;
    const max = 10;
    const optimalMax = 1;
    const moderateMax = 3;
    // Helper to clamp and map 0-10 range to percentage
    const mapValueToPercent = (value, lower, upper) => {
      const clamped = Math.max(lower, Math.min(upper, value));
      return ((clamped - lower) / (upper - lower)) * 100;
    };
    // Calculate marker position as % (0–100)
    const percent = mapValueToPercent(crpValue, min, max);
    let riskLabel = "OPTIMAL";
    let riskColor = "#b6e2b6";
    let grade = 1;
    let gradeLabel = "Grade 1";
    let gradeDesc = "Optimal Level";
    let gradeColor = "#b6e2b6";
    let gradeRange = "< 0.5   /L";
    let gradeText = "Optimal level";
    let gradeExplain = "hs-CRP in this range suggests minimal systemic inflammation.";
    if (crpValue > moderateMax) {
      riskLabel = "HIGH RISK";
      riskColor = "#ed7b8c";
      grade = 4;
      gradeLabel = "Grade 4";
      gradeDesc = "High Risk (3.1–10.0 mg/L)";
      gradeColor = "#ed7b8c";
      gradeRange = "3.1 - 10.0 mg/L";
      gradeText = "High Risk";
      gradeExplain = "hs-CRP in this range suggests significant systemic inflammation and an elevated risk of chronic disease development if left unaddressed.";
    } else if (crpValue > optimalMax) {
  riskLabel = "MODERATE RISK";
  riskColor = "#ffe48a"; // Updated yellow shade for MODERATE RISK
  grade = 3;
  gradeLabel = "Grade 3";
  gradeDesc = "Moderate Risk (1.1–3.0 mg/L)";
  gradeColor = "#ffe48a"; // Updated yellow shade for MODERATE RISK
  gradeRange = "1.1 - 3.0 mg/L";
  gradeText = "Moderate Risk";
  gradeExplain = "hs-CRP in this range suggests moderate systemic inflammation.";
    } else if (crpValue > 0.5) {
      grade = 2;
      gradeLabel = "Grade 2";
      gradeDesc = "Low Risk (0.5–1.0 mg/L)";
      gradeColor = "#ffe08a";
      gradeRange = "0.5 - 1.0 mg/L";
      gradeText = "Low Risk";
      gradeExplain = "hs-CRP in this range suggests low systemic inflammation.";
    }

  })()
}
  // Helper function to wait for logo to load before PDF download
  const waitForLogoToLoad = () => {
    return new Promise((resolve) => {
      const img = document.getElementById("report-logo");
      if (!img) return resolve(); // No logo? Just resolve.
      if (img.complete) {
        resolve(); // Already loaded
      } else {
        img.onload = resolve;
        img.onerror = resolve; // still resolve to avoid hanging
      }
    });
  };

function Loader() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#fff' }}>
      <img src={process.env.PUBLIC_URL + '/empty.gif'} alt="Loading..." style={{ width: '120px', height: '120px' }} />
    </div>
  );
}

const feelGut = {
  "header": "/headerfg.png",
  "footer": "/footerfg.png",
  "logo": "/logofg.png",
  "primaryColor": "#724e9e",
  "secondaryColor": "#4180b8",
  "fontColor": "#003074",
  // "secondaryColor":"#00E596",
}
const rootCause = {
  "header": "blank.png",
  "footer": "blank.png",
  "logo": "/logorc.png",
  "primaryColor": "#5b6f89",
  "secondaryColor": "#91ecf3",
}
const testMe = {
  "header": "blank.png",
  "footer": "blank.png",
  "logo": "/logotestme.png",
  "primaryColor": "#04BACF",
  "secondaryColor": "#BOBOBO",
}

const Header = (reportStyle) => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      {/* <img src={reportStyle["logo"]} alt="logo" style={{ margin: '1.5rem', height: '6rem', width: '6rem' }} /> */}
      {/* <img src="/design4.png" alt="design" style={{ width: "100%" }} /> */}
      <img src={reportStyle["header"]} alt="Header" crossOrigin="anonymous" style={{ width: reportStyle === feelGut ? "20%" : "100%" }} />
    </div>
  );
};
const calculateMargins = (targetValue) => {
  const baseValue = 1250; // Reference value
  const incrementStep = 100; // Step size for increments
  const marginIncrement = 1.8; // Margin increment per step

  // Extreme conditions
  if (targetValue === 2500) {
    return { marginLeft: "25.5rem", marginRight: "0" };
  }

  if (targetValue === 0) {
    return { marginLeft: "0", marginRight: "23.5rem" };
  }

  if (targetValue > 2500) {
    return { marginLeft: "28rem", marginRight: "0" };
  }

  if (targetValue < 0) {
    return { marginLeft: "0", marginRight: "26rem" };
  }

  // Gradual margin calculation for values between 0 and 2500 (excluding extremes)
  const difference = targetValue - baseValue;

  if (difference > 0) {
    // For values greater than 1250, increase marginLeft only
    const marginLeft = (difference / incrementStep) * marginIncrement;
    return { marginLeft: `${marginLeft}rem`, marginRight: "0" };
  } else {
    // For values less than 1250, increase marginRight only
    const marginRight =
      (Math.abs(difference) / incrementStep) * marginIncrement;
    return { marginLeft: "0", marginRight: `${marginRight}rem` };
  }
};
const Footer = (reportStyle) => {
  return (
    <div style={{ display: "flex", justifyContent: "end", alignItems: "end", height: reportStyle === feelGut ? "28%" : "auto", paddingBottom: "0px" }}>
      {/* <img src="/design3.png" alt="design2" style={{ width: "100%" }} /> */}
      <img src={reportStyle["footer"]} alt="design2" style={{ width: reportStyle === feelGut ? "20%" : "101%", marginRight: "-0.45rem" }} />
      {/* <img src="/design3.png" alt="design2" style={{ width: '91.6667%' }} /> */}
    </div>
  );
};
function Box(value, text, color, styleName) {
  return (
    <div
      style={{
        height: "2.25rem",
        width: "11.4rem",
        display: "flex",
        borderRadius: "0.75rem",
        borderWidth: "2px",
        alignItems: "start",
        overflow: "hidden",
        borderColor: color,
        textAlign: "center",
        borderStyle: "solid", // Ensures border style is set
        // overflow: 'visible',
      }}
    >
      <div
        style={{
          height: "2.9rem",
          width: "4rem",
          padding: 0,
          margin: 0,
          fontSize: "0.75rem",
          fontWeight: "bold",
          // color:   (styleName=== "Allergymapdx" && color==='#ffff00') ? "black" :"white",
          // color: (styleName === "Allergymapdx" && color?.toLowerCase() === '#ffff00') ? "black" : "white",
          color: "black",
          backgroundColor: color,
          display: "flex",
          justifyContent: "center",
          paddingTop: "0.65rem",
          // alignItems: 'center',
        }}
      >
        {value}
      </div>
      <div
        style={{
          height: "2.5rem",
          width: "100%",
          // backgroundColor:"red",
          padding: 0,
          margin: 0,
          fontSize:
            text.length < 12
              ? "0.7rem"
              : text.length < 20
                ? "0.65rem"
                : "0.53rem",
          fontWeight: "bold",
          color: "black",
          display: "flex",
          justifyContent: "center",
          // alignItems: 'center',
          marginTop: "0.45rem",
          paddingTop: "2px",
        }}
      >
        {text}
      </div>
    </div>
  );
}
const getColor = (value, styleName) => {
  // if (value >= 0 && value <10) return styleName=== "Allergymapdx" ? "#00b388" : "#4380b6"; // Color for 'blue'
  // if (value >= 10 && value < 20) return  styleName=== "Allergymapdx" ? "#ffff00" :  "#ce9140"; // Color for 'golden'
  // if (value >= 20) return "#d13a3d"; // Color for 'red'
  if (value >= 0 && value < 10) return "#32b44a"; // Color for 'blue'
  if (value >= 10 && value < 20) return "#ccbd2c"; // Color for 'golden'
  if (value >= 20) return "#dd1f2e"; // Color for 'red'

  return ""; // Default or empty if no match
};
const getName = (key) => {
  const data = {
    "GD1": "GD1",
    "GD2": "GD2",
    "GD3": "GD3",
    "Ach d": "House cricket",
    "Aci spp.": "Caviar",
    "Act d": "Kiwi",
    "Ada d": "Baobab",
    "Aga": "Agar Agar",
    "Aga b": "White mushroom",
    // "Aga c": "White",
    "All a": "Shallot",
    "All c": "Onion",
    "All p": "Leek",
    "All s": "Garlic",
    "All sc": "Chives",
    "All u": "Wild garlic",
    "Alo v": "Aloe",
    "Ama t": "Amaranth",
    "Ame a": "Tea, black",
    "Ana c": "Pineapple",
    "Ana o": "Cashew",
    "Ana p": "Duck",
    "Ane g": "Dill",
    "Ang a": "Eel",
    "Api g": "Celery Bulb",
    "Api g_stalk": "Celery Stalk",
    "Api m_honey": "Honey",
    "Ara h": "Peanut",
    "Arc l": "Greater burdock root",
    "Arm r": "Horseradish",
    "Aro spp.": "Aronia",
    "Art d": "Tarragon",
    "Asp n": "Aspergillus niger",
    "Asp o": "White asparagus",
    "Ast a": "Noble crayfish",
    "Ave s": "Oat",
    "Bam v": "Bamboo sprouts",
    "Ber e": "Brazil nut",
    "Bet vu": "Chard",
    "Bet vul": "Red beet",
    "Bol e": "Boletus",
    "Bos d 4": "Cow's milk Bos d 4 * (Alpha-Lactalbumin)",
    "Bos d 5": "Cow's milk Bos d 5 * (Beta-Lactoglobulin)",
    "Bos d 8": "Cow's milk Bos d 8 * (Casein)",
    "Bos d_but": "Buttermilk",
    "Bos d_Ca": "Camembert",
    "Bos d_Em": "Emmental",
    "Bos d_Go": "Gouda",
    "Bos d_Hue": "Cottage cheese",
    "Bos d_meat": "Beef",
    "Bos d_milk": "Cow's milk",
    "Bos d_Mo": "Mozzarella",
    "Bos d_Pa": "Parmesan",
    "Bos d_veal_meat": "Veal",
    "Bra n": "Rapeseed",
    "Bra o": "Cabbage",
    "Bra o_bot": "Cauliflower",
    "Bra o_cap": "White cabbage",
    "Bra o_gem": "Brussels sprouts",
    "Bra o_gon": "Kohlrabi",
    "Bra o_ita": "Broccoli",
    "Bra o_rom": "Romanesco",
    "Bra o_rub": "Red cabbage",
    "Bra o_sab": "Green cabbage",
    "Bra o_saba": "Savoy",
    "Bra r": "Turnip",
    "Bra ra_chi": "Pok-Choi",
    "Bra ra_pek": "Chinese cabbage",
    "Bub b_milk": "Buffalo milk",
    "Cam d": "Camel milk",
    "Cam s": "Tea, green",
    "Can c": "Chanterelle",
    "Can s_seed": "Hempseed",
    "Cap a": "Paprika",
    "Cap c": "Venison",
    "Cap f": "Cayenne pepper",
    "Cap f_chi": "Chili (red)",
    "Cap h_cheese": "Goat cheese",
    "Cap h_meat": "Goat",
    "Cap h_milk": "Goat milk",
    "Cap s": "Caper",
    "Car c": "Caraway",
    "Car i": "Pecan nut",
    "Car p": "Papaya",
    "Car spp.": "Cockle",
    "Car t": "Safflower oil",
    "Cas s": "Sweet chestnut",
    "Cer e": "Stag",
    "Che q": "Quinoa",
    "Chi spp.": "Crab",
    "Chl spp.": "Chlorella",
    "Cic a": "Chickpea",
    "Cic e": "Endive",
    "Cic if": "Chicorée",
    "Cic i_fol": "Radicchio",
    "Cin v": "Cinnamon",
    "Cit a": "Lime",
    "Cit l": "Lemon",
    "Cit la": "Watermelon",
    "Cit p": "Grapefruit",
    "Cit r": "Tangerine",
    "Cit s": "Orange",
    "Clu h": "Atlantic herring",
    "Coc n": "Coconut milk",
    "Coc n_nut": "Coconut",
    "Cof a": "Coffee",
    "Col_spp": "Kola nut",
    "Con spp.": "Curry",
    "Cor a_hazel": "Hazelnut",
    "Cor s": "Coriander",
    "Cot c": "Quail egg",
    "Cuc m": "Melon",
    "Cuc met": "Kiwano",
    "Cuc m_butternut": "Pumpkin Butternut",
    "Cuc m_hoc": "Pumpkin Hokkaido",
    "Cuc p": "Pumpkin seed",
    "Cuc pe": "Zucchini",
    "Cuc s": "Cucumber",
    "Cum c": "Cumin",
    "Cur l": "Turmeric",
    "Cym c": "Lemongrass",
    "Cyn c": "Artichoke",
    "Cyp c": "Carp",
    "Cyp e": "Tigernut",
    "Dau c": "Carrot",
    "Ele c": "Cardamom",
    "Eng e": "European anchovy",
    "Equ c_meat": "Horse",
    "Eru s": "Arugula",
    "Eso l": "Northern pike",
    "Fag e": "Buckwheat",
    "Fic c": "Fig",
    "Fla v": "Enoki",
    "Foe v": "Fennel (bulb)",
    "Fra a": "Strawberry",
    "Gad m": "Atlantic cod",
    "Gal d_meat": "Chicken",
    "Gal d_white": "Egg white",
    "Gal d_yolk": "Egg yolk",
    "Gin b": "Ginkgo",
    "Gly m": "Soy",
    "Hal g": "Abalone",
    "Hel a": "Sunflower",
    "Hib s": "Hibiscus",
    "Hom g": "Lobster",
    "Hom s LF": "Human Lactoferrin",
    "Hor v": "Barley",
    "Hor v_malt": "Malt (barley)",
    "Hum l": "Hops",
    "IgG_Std1": "IgG_Std1",
    "IgG_Std2": "IgG_Std2",
    "IgG_Std3": "IgG_Std3",
    "IgG_Std4": "IgG_Std4",
    "IgG_Std5": "IgG_Std5",
    "Ipo b": "Sweet potato",
    "Jas o": "Jasmine",
    "Jug r_nut": "Walnut",
    "Jun c": "Juniper berry",
    "Lau n": "Bay leaf",
    "Len c": "Lentil",
    "Lep m": "Maca root",
    "Lep s": "Watercress",
    "Lin u": "Linseed",
    "Lit c": "Lychee",
    "Lit s": "Shrimp mix",
    "Loc m": "Migratory locust",
    "Lol spp.": "Squid",
    "Lop p": "Monkfish",
    "Lup a": "Lupine seed",
    "Mac inte": "Macadamia",
    "Mal d": "Apple",
    "Man e": "Tapioca",
    "Man i": "Mango",
    "Mat c": "Chamomile",
    "Mel a": "Haddock",
    "Mel g": "Turkey",
    "Men p": "Peppermint",
    "Mer c": "Hake",
    "Mor o": "Moringa",
    "Mor spp._berry": "Mulberry",
    "Mus a": "Banana",
    "Myr f": "Nutmeg",
    "Myt e": "Common mussel",
    "Nep c": "Mint",
    "Oci b": "Basil",
    "Oct v": "Octopus",
    "Ole_fruit": "Olive",
    "Onc m": "Trout",
    "Ori m": "Majoram",
    "Ori v": "Oregano",
    "Ory s": "Rice",
    "Ory_meat": "Rabbit",
    "Ost e": "Oyster",
    "Ovi a_cheese": "Sheep cheese",
    "Ovi a_meat": "Lamb",
    "Ovi a_milk": "Sheep milk",
    "Pan b": "Northern prawn",
    "Pan g": "Ginseng",
    "Pan m": "Millet",
    "Pap s": "Poppyseed",
    "Pas e": "Passion fruit",
    "Pas s": "Parsnip",
    "Pau c": "Guarana",
    "Pec spp.": "Scallop",
    "Pers a": "Avocado",
    "Pet c": "Parsley",
    "Pha spp.": "Razor shell",
    "Pha v": "White bean",
    "Pha v_green": "Green bean",
    "Pho d_fruit": "Date",
    "Phy p": "Physalis",
    "Pim a": "Anise",
    "Pin k": "Pine nut",
    "Pip n": "Pepper ⚫⚪🟢🔴🟡",
    "Pis s": "Pea",
    "Pis s_conv": "Sugar pea",
    "Pis v": "Pistachio",
    "Ple e": "French horn mushroom",
    "Ple o": "Oyster mushroom",
    "Ple p": "European plaice",
    "Pru ar": "Apricot",
    "Pru av": "Cherry",
    "Pru do": "Plum",
    "Pru du": "Almond",
    "Pru du_milk": "Almond milk",
    "Pru p": "Peach",
    "Pru p_nuc": "Nectarine",
    "Pun g": "Pomegranate",
    "Pyr c": "Pear",
    "Pyr y": "Nori",
    "Raj c": "Thornback Ray",
    "Rap s": "Radish",
    "Rib g": "Gooseberry",
    "Rib r": "Red currant",
    "Ros o": "Rosmary",
    "Rub f": "Blackberry",
    "Rub i": "Raspberry",
    "Rud spp.": "Venus clam",
    "Sac c": "Baker's yeast",
    "Sac o": "Cane sugar",
    "Sac u": "Brewer's yeast",
    "Sal h": "Chia seed",
    "Sal o": "Sage",
    "Sal s": "Salmon",
    "Sam f": "Elderflower",
    "Sam n": "Elderberry",
    "Sar p": "European pilchard",
    "Sco m": "Turbot",
    "Sco s": "Mackerel",
    "Seb m": "Atlantic redfish",
    "Sec c_flour": "Rye",
    "Sep spp.": "Sepia",
    "Ses i": "Sesame",
    "Sin": "Mustard",
    "Sma s": "Yacón root",
    "Sol m": "Eggplant",
    "Sol s": "Sole",
    "Sol t": "Potato",
    "Sola l": "Tomato",
    "Spa a": "Gilt-head bream",
    "Spi o": "Spinach",
    "Spi spp.": "Spirulina",
    "Str c": "Ostrich",
    "Str m": "M-Transglutaminase, meat glue",
    "Sus d_meat": "Pork",
    "Sus s_meat": "Boar",
    "Syz a": "Clove",
    "Tam i": "Tamarind",
    "Tar v": "Dandelion root",
    "Ten m": "Mealworm",
    "The c": "Cocoa",
    "Thu a": "Tuna",
    "Thy v": "Thyme",
    "Tri a": "Wheat",
    "Tri a Gliadin": "Wheat gliadin",
    "Tri ae": "Gluten",
    "Tri a_bran": "Wheat bran",
    "Tri a_grass": "Wheatgrass",
    "Tri d": "Emmer",
    "Tri du": "Durum",
    "Tri fo": "Fenugreek",
    "Tri m": "Einkorn",
    "Tri p": "Polish wheat",
    "Tri s": "Spelt",
    "Und p": "Wakame",
    "Urt d_leaf": "Nettle leaves",
    "Vac m": "Blueberry",
    "Vac m_cra": "Cranberry",
    "Val l": "Lamb's lettuce",
    "Van p": "Vanilla",
    "Vig r": "Mung bean",
    "Vit v": "Grape",
    "Vit v_ros": "Raisin",
    "Xip g": "Swordfish",
    "Zea m": "Corn",
    "Zin o": "Ginger",
  };

  const value = data[key];
  return value;
};
// const categories = {
//   "Fish & Seafood": [
//     "Abalone",
//     "Atlantic cod",
//     "Atlantic herring",
//     "Atlantic redfish",
//     "Carp",
//     "Caviar",
//     "Cockle",
//     "Common mussel",
//     "Crab",
//     "Eel",
//     "European anchovy",
//     "European pilchard",
//     "European plaice",
//     "Gilt-head bream",
//     "Haddock",
//     "Hake",
//     "Lobster",
//     "Mackerel",
//     "Monkfish",
//     "Noble crayfish",
//     "Northern pike",
//     "Northern prawn",
//     "Oyster",
//     "Octopus",
//     "Razor shell",
//     "Salmon",
//     "Scallop",
//     "Sepia",
//     "Shrimp mix",
//     "Sole",
//     "Squid",
//     "Swordfish",
//     "Thornback Ray",
//     "Trout",
//     "Tuna",
//     "Turbot",
//     "Venus clam",
//   ],

//   "Novel Foods": [
//     "Almond milk",
//     "Aloe",
//     "Aronia",
//     "Baobab",
//     "Chia seed",
//     "Chlorella",
//     "Dandelion root",
//     "Ginkgo",
//     "Ginseng",
//     "Greater burdock root",
//     "Guarana",
//     "House cricket",
//     "Maca root",
//     "Mealworm",
//     "Migratory locust",
//     "Nori",
//     "Safflower oil",
//     "Spirulina",
//     "Tapioca",
//     "Wakame",
//     "Yacón root",
//   ],

//   Nuts: [
//     "Almond",
//     "Brazil nut",
//     "Cashew",
//     "Coconut",
//     "Coconut milk",
//     "Hazelnut",
//     "Kola nut",
//     "Macadamia",
//     "Pecan nut",
//     "Pistachio",
//     "Sweet chestnut",
//     "Tigernut",
//     "Walnut",
//   ],

//   Others: [
//     "Agar Agar",
//     "Aspergillus niger",
//     "Baker's yeast",
//     "Brewer's yeast",
//     "Cane sugar",
//     "Elderflower",
//     "Honey",
//     "Hops",
//     "M-Transglutaminase, meat glue",
//   ],

//   "Cereals & Seeds (Gluten Containing)": [
//     "Barley",
//     "Malt (barley)",
//     "Rye",
//     "Wheat",
//     "Wheat gliadin",
//     "Wheat bran",
//     "Wheatgrass",
//     "Gluten",
//     "Gluten",
//     "Durum",
//     "Emmer",
//     "Einkorn",
//     "Polish wheat",
//     "Spelt",
//   ],

//   "Cereals & Seeds (Gluten Free)": [
//     "Amaranth",
//     "Oat",
//     "Rapeseed",
//     "Hempseed",
//     "Quinoa",
//     "Pumpkin seed",
//     "Buckwheat",
//     "Sunflower",
//     "Linseed",
//     "Lupine seed",
//     "Rice",
//     "Millet",
//     "Poppyseed",
//     "Pine nut",
//     "Sesame",
//     "Sesame",



//   ],

//   Spices: [
//     "Anise",
//     "Basil",
//     "Bay leaf",
//     "Caraway",
//     "Cardamom",
//     "Cayenne pepper",
//     "Chili (red)",
//     "Cinnamon",
//     "Clove",
//     "Coriander",
//     "Mustard",
//     "Cumin",
//     "Curry",
//     "Dill",
//     "Fenugreek",
//     "Ginger",
//     "Juniper berry",
//     "Lemongrass",
//     "Majoram",
//     "Mint",
//     "Nutmeg",
//     "Oregano",
//     "Paprika",
//     "Parsley",
//     "Pepper ⚫⚪🟢🔴🟡",
//     "Rosmary",
//     "Sage",
//     "Tarragon",
//     "Thyme",
//     "Turmeric",
//     "Vanilla",
//   ],

//   Fruits: [
//     "Apple",
//     "Apricot",
//     "Banana",
//     "Blackberry",
//     "Blueberry",
//     "Cherry",
//     "Cranberry",
//     "Date",
//     "Elderberry",
//     "Fig",
//     "Grape",
//     "Grapefruit",
//     "Gooseberry",
//     "Kiwi",
//     "Lemon",
//     "Lime",
//     "Lychee",
//     "Mango",
//     "Melon",
//     "Mulberry",
//     "Nectarine",
//     "Orange",
//     "Papaya",
//     "Passion fruit",
//     "Peach",
//     "Pear",
//     "Physalis",
//     "Pineapple",
//     "Plum",
//     "Pomegranate",
//     "Raisin",
//     "Raspberry",
//     "Red currant",
//     "Strawberry",
//     "Tangerine",
//     "Watermelon",
//   ],

//   Vegetables: [
//     "Garlic",
//     "Artichoke",
//     "Arugula",
//     // "Asparagus",
//     "White asparagus",
//     "Avocado",
//     "Bamboo sprouts",
//     "Broccoli",
//     "Brussels sprouts",
//     "Cabbage",
//     "Caper",
//     "Carrot",
//     "Cauliflower",
//     "Celery Bulb",
//     "Celery Stalk",
//     "Chard",
//     "Chicorée",
//     "Chinese cabbage",
//     "Chives",
//     "Cucumber",
//     "Eggplant",
//     "Endive",
//     "Fennel (bulb)",
//     "Green bean",
//     "Green cabbage",
//     "Horseradish",
//     "Kiwano",
//     "Kohlrabi",
//     "Lamb's lettuce",
//     "Leek",
//     "Nettle leaves",
//     "Olive",
//     "Onion",
//     "Parsnip",
//     "Pea",
//     "Pok-Choi",
//     "Pumpkin Butternut",
//     "Pumpkin Hokkaido",
//     "Radicchio",
//     "Radish",
//     "Red beet",
//     "Red cabbage",
//     "Romanesco",
//     "Savoy",
//     "Shallot",
//     "Spinach",
//     "Sweet potato",
//     "Tomato",
//     "Turnip",
//     "Watercress",
//     "White cabbage",
//     "Wild garlic",
//     "Zucchini",
//     "Potato",
//   ],

//   Meat: [
//     "Beef",
//     "Boar",
//     "Chicken",
//     "Duck",
//     "Goat",
//     "Horse",
//     "Lamb",
//     "Ostrich",
//     "Pork",
//     "Rabbit",
//     "Stag",
//     "Turkey",
//     "Veal",
//     "Venison",
//   ],

//   "Herbal Teas & Coffee": [
//     "Chamomile",
//     "Cocoa",
//     "Coffee",
//     "Hibiscus",
//     "Jasmine",
//     "Moringa",
//     "Peppermint",
//     "Tea, black",
//     "Tea, green",
//   ],

//   "Edible Mushrooms": [
//     "Boletus",
//     "Chanterelle",
//     "Enoki",
//     "French horn mushroom",
//     "Oyster mushroom",
//     "White mushroom",
//   ],

//   "Dairy Products & Egg": [
//     "Buffalo milk",
//     "Buttermilk",
//     "Camel milk",
//     "Camembert",
//     "Cottage cheese",
//     "Cow's milk",
//     "Cow's milk Bos d 4 * (Alpha-Lactalbumin)",
//     "Cow's milk Bos d 5 * (Beta-Lactoglobulin)",
//     "Cow's milk Bos d 8 * (Casein)",
//     "Egg white",
//     "Egg yolk",
//     "Emmental",
//     "Goat cheese",
//     "Goat milk",
//     "Gouda",
//     "Mozzarella",
//     "Parmesan",
//     "Quail egg",
//     "Sheep cheese",
//     "Sheep milk",
//   ],

//   Legumes: [
//     "Chickpea",
//     "Green bean",
//     "Lentil",
//     "Mung bean",
//     "Pea",
//     "Peanut",
//     "Soy",
//     "Sugar pea",
//     "Tamarind",
//     "White bean",
//   ],
//   CCD: ["Human Lactoferrin"],
// };




const categories = {
  "Fish & Seafood": [
    "Haddock",
    "Crab",
    "Northern prawn",
    "Salmon",
    "Tuna",
    "Lobster",
    "Atlantic herring",
    "Mackerel",
  ],

  "Novel Foods": [
    "Baker's yeast",
    "Brewer's yeast",
    
  ],

  Nuts: [
    "Cashew",
    "Walnut",
    "Almond",
    "Brazil nut",
    "Hazelnut",
    "Peanut",
    "Coconut",
  ],

  Others: [
    "Bakers yeast",
    "Brewers yeast",
    
  ],

  "Cereals & Seeds (Gluten Containing)": [
    "Wheat",
    "Gluten",
    "Barley",
    "Rye",
    "Spelt",
    
  ],

  "Cereals & Seeds (Gluten Free)": [
    "Corn",
    "Sesame",
    "Linseed",
    "Sunflower",
    "Rapeseed",
    "Oat",
    "Buckwheat",
    "Rice",
    "Quinoa",
    "Hempseed",
    "Pine nut",
  ],

  Spices: [
    "Ginger",
    "Pepper ⚫⚪🟢🔴🟡",
    "Nutmeg",
    "Vanilla",
  ],

  Fruits: [
    "Kiwi",
    "Lime",
    "Grapefruit",
    "Melon",
    "Nectarine",
    "Raspberry",
    "Elderberry",
    "Pineapple",
    "Lemon",
    "Apricot",
    "Apple",
    "Banana",
    "Plum",
    "Peach",
    "Grape",
    "Watermelon",
    "Orange",
    "Strawberry",
    "Raisin",
    "Pear",
  ],

  Vegetables: [
    "Garlic",
    "Onion",
    "Leek",
    // "Asparagus",
    "Cauliflower",
    "Broccoli",
    "Carrot",
    "Sweet potato",
    "Parsnip",
    "Pea",
    "Tomato",
    "Cucumber",
    "Avocado",
    "Spinach",
    "Turnip",
    "Green bean",
    "Celery Stalk",
    "Brussels sprouts",
  ],
  

  Meat: [
    "Pork",
    "Beef",
    "Chicken",
    "Lamb",
    "Turkey",
   
  ],

  "Herbal Teas & Coffee": [
    "Chamomile",
    "Cocoa",
    "Coffee",
    "Hibiscus",
    "Jasmine",
    "Moringa",
    "Peppermint",
    "Tea, black",
    "Tea, green",
  ],

  "Edible Mushrooms": [
        "Chanterelle",
        "White mushroom",
       ],

  "Dairy Products & Egg": [
    "Cottage cheese",
    "Egg yolk",
    "Egg white",
    "Sheep cheese",
    "Goat cheese",
    "Goat milk",
    "Cow's milk"

  ],

  Legumes: [
    "Lentil",
    "Mung bean",
    "Chickpea",
    "Soy",
  ],
  "Tea & coffee": [
    "Tea, black",
    "Coffee",
    "Cocoa",
    
  ],
  CCD: ["Human Lactoferrin"],
};

function lightenColorWithOpacity(color, percent, opacity) {
  const num = parseInt(color.replace("#", ""), 16);
  const amt = Math.round(2.55 * percent);
  const R = Math.min(255, Math.max(0, (num >> 16) + amt));
  const G = Math.min(255, Math.max(0, (num >> 8 & 0x00FF) + amt));
  const B = Math.min(255, Math.max(0, (num & 0x0000FF) + amt));

  return `rgba(${R}, ${G}, ${B}, ${opacity})`;
}



const Page = () => {

  let yourGutMap = {}


  // const [categories, setCategories] = useState(categories1)
  const [reportStyle, setReportStyle] = useState(yourGutMap)
  const [myResponse, setMyResponse] = useState({});
  const [myResult, setMyResult] = useState([]);
  const [totalScore, setTotalScore] = useState(0);
  const [redBoxes, setRedBoxes] = useState(0);
  const [yellowBoxes, setYellowBoxes] = useState(0);
  const [fishBoxes, setFishBoxes] = useState([]);
  const [vegetableBoxes, setVegetableBoxes] = useState([]);
  const [margins, setMargins] = useState({});
  const [portalid, setPortalId] = useState();
  const [totalPages, setTotalPages] = useState('14');
  const btn = useRef();
  const [loading, setLoading] = useState(true);

  const { id } = useParams();
  const mainLogo = "/images/ygmlogo.png";


  const [primaryColor, setPrimaryColor] = useState("#724e9e");
  // const [primaryColor,setPrimaryColor] = useState("red");
  const [secondaryColor, setSecondaryColor] = useState("#4180b8");
  // const [secondaryColor,setSecondaryColor] = useState("green");
  const [logo, setLogo] = useState("/blank.png");
  const [styleName, setStyleName] = useState("YourGutMap");
  const [header, setHeader] = useState()
  const [footer, setFooter] = useState()
  const [isUpdated, setIsUpdated] = useState(false)
  const reportRef = useRef(null)

  const handleDownload = async () => {
    try {
      const target = reportRef.current;
      if (!target) return;
      const canvas = await html2canvas(target, { scale: 2, useCORS: true });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("report.pdf");
    } catch (e) {
      console.error(e);
      message.error("Failed to generate PDF");
    }
  };



  //   yourGutMap = {
  //     "header": styleName === 'YourGutMap' ? "/design4.png" : "blank.png",
  //     "footer": styleName === 'YourGutMap' ? "/design3.png" : "blank.png",
  //     "logo":logo,
  //     "primaryColor":primaryColor,
  //     "secondaryColor":secondaryColor,
  //     "fontColor":primaryColor,
  // }

  useEffect(() => {
    const updatedMap = {
      header: styleName === 'YourGutMap' || 'Your Gut Map' ? "/design4.png" : "/blank.png",
      footer: styleName === 'YourGutMap' ? "/design3.png" : "/blank.png",
      logo: logo,
      primaryColor: primaryColor,
      secondaryColor: secondaryColor,
      fontColor: primaryColor,
      header: header || '/blank.png',
      footer: footer || '/blank.png',
    };
    setReportStyle(updatedMap);
  }, [styleName, logo, primaryColor, secondaryColor]);



  useEffect(() => {
    const fetchReportStyle = async () => {
      setLoading(true);
      try {
        const response = await fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/getReportStyleByKit", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ kitId: id }),
        });
        const result = await response.json();
        if (response.ok && result.style) {
          setPrimaryColor(result.style.primaryColor);
          setSecondaryColor(result.style.secondaryColor);
          setLogo(result.style.imageBase64);
          setStyleName(result.style.styleName);
          setHeader(result.style.header);
          setFooter(result.style.footer);
          setIsUpdated(true)
          setPortalId(result.style._id);
        }
      } catch (error) {
        console.error("Error fetching report style:", error);
      }
      setLoading(false);
    };
    fetchReportStyle();
  }, [id]);
  useEffect(() => {
    const totalCount = myResult.filter((data) => data.value >= 20).length;
    const totalCount2 = myResult.filter(
      (data) => data.value >= 10 && data.value < 20
    ).length;
    const fishAndSeafoodItems = Array.isArray(myResult)
      ? myResult.filter((data) =>
        (categories["Fish & Seafood"] || []).includes(getName(data.name))
      )
      : [];
    const vegetable = Array.isArray(myResult)
      ? myResult.filter((data) =>
        (categories["Vegetables"] || []).includes(getName(data.name))
      )
      : [];
    console.log("Filtered Fish & Seafood Items:", fishAndSeafoodItems);
    setRedBoxes(totalCount);
    setYellowBoxes(totalCount2);
    setFishBoxes(fishAndSeafoodItems);
    setVegetableBoxes(vegetable);
  }, [myResult]);

  useEffect(() => {
    if (redBoxes + yellowBoxes <= 33) {
      setTotalPages('14');
    }
    else {
      setTotalPages('15');
    }
  }, [redBoxes])

  useEffect(() => {
    const getdata = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      const urlencoded = new URLSearchParams();
      urlencoded.append("_id", id);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
        redirect: "follow",
      };
      try {
        const response = await fetch(
          "https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/viewreportdata",
          requestOptions
        );
        const result = await response.json();
        setMyResponse(result);
        setMyResult(result.result);
      } catch (error) {
        console.log("error", error);
      }
    };
    getdata();
  }, []);

  useEffect(() => {
    // Calculate the sum of rounded values in myResult array
    const sum = myResult.reduce((accumulator, currentValue) => {
      return accumulator + Math.round(currentValue.value);
    }, 0);
    // Only update state if the sum has changed to avoid unnecessary re-renders
    if (sum !== totalScore) {
      setTotalScore(sum);
    }
    const newMargin = calculateMargins(totalScore);
    setMargins(newMargin);
  }, [myResult, totalScore]); // The effect depends on both myResult and totalScore

  // Show loader if loading
  if (loading) {
    return <Loader />;
  }
  const download = async () => {
    await waitForLogoToLoad();
    await new Promise((resolve) => setTimeout(resolve, 300));
    const hide = message.loading("Your report is downloading", 0);
    const buttons = document.querySelectorAll('.download-btn');
    buttons.forEach((b) => b.classList.add('hide-for-pdf'));

    try {
      const pdf = new jsPDF();
      const pages = document.querySelectorAll(".page1");

      for (let i = 0; i < pages.length; i++) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        const canvas = await html2canvas(pages[i], { scale: 2, useCORS: true, background: "#ffffff" }); // Higher scale for better quality and consistent background
        const imgData = canvas.toDataURL("image/jpeg", 0.9); // JPEG format with 90% quality

        if (i > 0) {
          pdf.addPage();
        }

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * pageWidth) / canvas.width; // Maintain aspect ratio

        pdf.addImage(
          imgData,
          "JPEG",
          0,
          0,
          imgWidth,
          imgHeight,
          undefined,
          "MEDIUM"
        );
      }

      pdf.save("food-sensitivity-report.pdf");


      hide();
      message.success("Report has been downloaded Successfully!");
    } catch (error) {
      console.log(error)
    }

    buttons.forEach((b) => b.classList.remove('hide-for-pdf'));
  };
  // useEffect(() => {
  //   if (myResponse.kitid != null) {
  // myResponse.reportstyle === 'YourGutMap Report Style' ? setReportStyle(yourGutMap) : myResponse.reportstyle === 'Root Cause Report Style' ? setReportStyle(rootCause) : myResponse.reportstyle === 'TestMe Report Style' ? setReportStyle(testMe) : setReportStyle(feelGut)
  // myResponse.reportstyle === 'YourGutMap Report Style' ? setReportStyle(yourGutMap) : setReportStyle(yourGutMap)
  // if(isUpdated === true){
  // download(); 
  //     }
  //   }
  // }, [isUpdated]);




  return (
    <div
      className="page-container"
      style={{
        width: "100%",
        display: "flex",
      }}
    >
      <div id="ali">
        
        {styleName === 'TestMe' ? <> <div className="page1"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "297mm",
            width: "210mm",
          }}
        >
          <div style={{ position: "relative", height: "100%", width: "100%" }}>
            
            <img
              src="/bgtestme.jpg"
              alt="background"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover", 
                zIndex: 0,
              }}
            />

            
            <img
              src="/testmelogo2.png"
              alt="logo"
              style={{
                position: "absolute",
                top: "4rem", 
                left: "2rem",
                width: "350px",
                zIndex: 1,
              }}
            />
            <h1 style={{
              position: "absolute",
              top: "31rem", // Adjust position as needed
              left: "3rem",
              // width: "650px",
              fontSize: "53px",
              zIndex: 2,
              color: "yellow"
            }}>FoodSensitivityMap</h1>
            <h1 style={{
              position: "absolute",
              top: "35rem", // Adjust position as needed
              left: "3rem",
              // width: "650px",
              fontSize: "44px",
              zIndex: 2,
              color: "white"
            }}>Test Report</h1>
            <button
              style={{
                position: "absolute",
                top: "45rem", // Adjust position as needed
                left: "14rem",
                width: "350px",
                height: "50px",
                border: "none",
                borderRadius: "10px",
                background: "white",
                fontSize: "25px",
                color: `${reportStyle["primaryColor"]}`
              }}
              className=""
              id="downloadButton"
              onClick={download}
            >
              Download
            </button>
            <div className="" style={{
              position: "absolute",
              top: "60rem", // Adjust position as needed
              right: "2rem",
              // width: "50px",
              zIndex: 1,
              display: "flex",
              justifyContent: "space-between",
              width: "90%",
              height: "80px",
            }}>
              <div className="">
                <div className="" style={{ height: "35px", width: "350px", background: "white", borderRadius: "20px", display: "flex", justifyContent: "start", paddingLeft: "20px", alignItems: "center", marginBottom: "10px" }}>Name : {myResponse?.patientName}</div>
                <div className="" style={{ height: "35px", width: "350px", background: "white", borderRadius: "20px", display: "flex", justifyContent: "start", paddingLeft: "20px", alignItems: "center" }}>Kit ID : {myResponse?.kitid == null ? "---" : myResponse?.kitid}</div>
              </div>
              <img
                src="/testmeend2.png"
                alt="logo"
                style={{
                  // width:"250px"
                }}
              />

            </div>
          </div>
        </div>
        </> : null}


        {styleName !== 'TestMe' ? <>


          {/* <img src={reportStyle["header"]} alt="header" style={{width:"100%"}}

        /> */}
        </> : null}

        {/* page 2 */}
       

        {/* page 3۔1.1*/}
        
        <div
          className="page1"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "297mm",
            width: "210mm",
          }}
        >


          <div
            style={{
              display: "flex",
              marginTop: "1rem",
              marginBottom: "5rem",
              flexDirection: "column",
              flexGrow: 1,
              alignItems: "center",
            }}
          >


            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
                width: "100%",
                marginTop: "3.4rem",
              }}
            >
              <div
                style={{
                  marginBottom: "1rem",
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  color: "black",
                  width: "15rem",
                  height: "2.5rem",
                  fontSize: "0.875rem",
                  borderRadius: "0.7rem",
                  backgroundColor: "#dd1f2e",
                  paddingTop: "0.8rem",
                  fontWeight: "600"
                }}
              >
                {"Elevated ≥ 20 IgG µg/ml"}
              </div>
              <HeaderComponent primaryColor={primaryColor} portalid={portalid} bg={lightenColorWithOpacity(primaryColor, 10, 0.10)} secondaryColor={secondaryColor} logo={logo} heading={"Food Sensitivity"} />
              <div
                style={{
                  marginBottom: "0.5rem",
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  color: "black",
                  width: "15rem",
                  height: "2.5rem",
                  fontSize: "0.875rem",
                  borderRadius: "0.7rem",
                  backgroundColor: "#ccbd2c",
                  paddingTop: "0.8rem", fontWeight: "600"
                }}
              >
                {"Borderline 10 - 19.99 IgG µg/ml"}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  // color: "white",
                  color: "black",
                  width: "15rem",
                  height: "2.5rem",
                  fontSize: "0.875rem",
                  borderRadius: "0.7rem",
                  backgroundColor: styleName === "Allergymapdx" ? "#32B44A" : "#32B44A",
                  paddingTop: "0.8rem", fontWeight: "600"
                }}
              >
                {"Normal 0 - 9.99 IgG µg/ml"}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                marginLeft: "3rem",
                marginTop: "0.4rem",
              }}
            >
              <h2
                style={{
                  color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                  fontWeight: "600",
                  fontSize: "1.8rem",
                  marginTop: "-1.5rem",
                  marginBottom: "0.4rem",
                }}
              >
                Dairy & Egg
              </h2>

            </div>

            <div
              style={{
                marginLeft: "1.5rem",
                display: "flex",
                flexWrap: "wrap",
                gap: "0.65rem",
                marginTop: "0rem",
              }}
            >
              {/* /Dairy Product and Eggs/ */}
              {myResult.map((data, index) => (
                <>
                  {/* {(categories[Object.keys(categories)[11]] || {}).includes( */}
                  {(categories['Dairy Products & Egg'] || {}).includes(
                    getName(data.name)
                  )
                    ? Box(
                      data.value.toFixed(2),
                      getName(data.name),
                      getColor(data.value, styleName), styleName
                    )
                    : null}
                </>
              ))}
            </div>



            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                marginLeft: "3rem",
                marginTop: "0.4rem",
              }}
            >
              <h2
                style={{
                  color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                  fontWeight: "600",

                  fontSize: "1.8rem",
                  marginTop: "0.2rem",
                  marginBottom: "0rem",
                }}
              >
                Cereals & Seeds{" "}
                <span style={{ fontStyle: "italic", fontWeight: "400", fontSize: "1.2rem", color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`, }}>
                  (Gluten Containing)
                </span>
              </h2>
            </div>

            <div
              style={{
                marginLeft: "1.5rem",
                display: "flex",
                flexWrap: "wrap",
                gap: "0.65rem",
                marginTop: "0rem",
              }}
            >
              {myResult.map((data, index) => (
                <>

                  {(categories['Cereals & Seeds (Gluten Containing)'] || {}).includes(
                    getName(data.name)
                  )
                    ? Box(
                      data.value.toFixed(2),
                      getName(data.name),
                      getColor(data.value, styleName), styleName
                    )
                    : null}
                </>
              ))}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                marginLeft: "3rem",
                marginTop: "0rem",
              }}
            >
              <h2
                style={{
                  color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                  fontWeight: "600",
                  
                  fontSize: "1.8rem",
                  marginTop: "0rem",
                  marginBottom: "0.4rem",
                }}
              >
                Cereals & Seeds{" "}
                <span style={{ fontStyle: "italic", fontWeight: "400", fontSize: "1.2rem", color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`, }}>
                  (Gluten Free)
                </span>
              </h2>


            </div>
            

            <div
              style={{
                marginLeft: "1.5rem",
                display: "flex",
                flexWrap: "wrap",
                gap: "0.65rem",
                marginTop: "0rem",
              }}
            >
              {myResult.map((data, index) => (
                <>

                  {(categories['Cereals & Seeds (Gluten Free)'] || {}).includes(
                    getName(data.name)
                  )
                    ? Box(
                      data.value.toFixed(2),
                      getName(data.name),
                      getColor(data.value, styleName), styleName
                    )
                    : null}
                </>
              ))}
            </div>
            
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                marginLeft: "3rem",
                marginTop: "0rem",
              }}
            >
              <h2
                style={{
                  color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                  fontWeight: "600",
                  fontSize: "1.8rem",
                  marginTop: "0.4rem",
                  
                  marginBottom: "0rem"
                }}
              >

                Meat
              </h2>
            </div>


            <div
              style={{
                marginLeft: "1.5rem",
                display: "flex",
                flexWrap: "wrap",
                gap: "0.65rem",
                marginTop: "0rem",
              }}
            >
              {myResult.map((data, index) => (
                <>

                  {(categories['Meat'] || {}).includes(
                    getName(data.name)
                  )
                    ? Box(
                      data.value.toFixed(2),
                      getName(data.name),
                      getColor(data.value, styleName), styleName
                    )
                    : null}
                </>
              ))}
              
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                marginLeft: "3rem",
                marginTop: "0rem",
              }}
            >
              <h2
                style={{
                  color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                  fontWeight: "600",
                  fontSize: "1.8rem",
                  marginTop: "0.4rem",
                  
                  marginBottom: "0rem"
                }}
              >

Fish & Seafood
              </h2>
            </div>


            <div
              style={{
                marginLeft: "1.5rem",
                display: "flex",
                flexWrap: "wrap",
                gap: "0.65rem",
                marginTop: "0rem",
              }}
            >
              {myResult.map((data, index) => (
                <>

                  {(categories['Fish & Seafood'] || {}).includes(
                    getName(data.name)
                  )
                    ? Box(
                      data.value.toFixed(2),
                      getName(data.name),
                      getColor(data.value, styleName), styleName
                    )
                    : null}
                </>
              ))}
              
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                marginLeft: "3rem",
                marginTop: "0rem",
              }}
            >
              <h2
                style={{
                  color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                  fontWeight: "600",
                  fontSize: "1.8rem",
                  marginTop: "0.2rem",
                  
                  marginBottom: "0rem"
                }}
              >

                Mushrooms
              </h2>
            </div>


            <div
              style={{
                marginRight: "46%",
                display: "flex",
                flexWrap: "wrap",
                gap: "0.65rem",
                marginTop: "0.2rem",
              }}
            >
              {myResult.map((data, index) => (
                <>

                  {(categories['Edible Mushrooms'] || {}).includes(
                    getName(data.name)
                  )
                    ? Box(
                      data.value.toFixed(2),
                      getName(data.name),
                      getColor(data.value, styleName), styleName
                    )
                    : null}
                </>
              ))}
              
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                marginLeft: "3rem",
                marginTop: "0rem",
              }}
            >
              <h2
                style={{
                  color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                  fontWeight: "600",
                  fontSize: "1.8rem",
                  marginTop: "0.2rem",
                  
                  marginBottom: "0.2rem"
                }}
              >

Legumes
              </h2>
            </div>


            <div
              style={{
                marginLeft: "1.5rem",
                display: "flex",
                flexWrap: "wrap",
                gap: "0.65rem",
                marginTop: "0.2rem",
              }}
            >
              {myResult.map((data, index) => (
                <>

                  {(categories['Legumes'] || {}).includes(
                    getName(data.name)
                  )
                    ? Box(
                      data.value.toFixed(2),
                      getName(data.name),
                      getColor(data.value, styleName), styleName
                    )
                    : null}
                </>
              ))}
              
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                marginLeft: "3rem",
                marginTop: "0rem",
              }}
            >
              <h2
                style={{
                  color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                  fontWeight: "600",
                  fontSize: "1.8rem",
                  marginTop: "0.2rem",
                  marginBottom: "0.2rem"
                }}
              >
                Tea & coffee
              </h2>
            </div>


     {categories === categories  &&        <div
              style={{
                marginRight: "20%",
                display: "flex",
                flexWrap: "wrap",
                gap: "0.65rem",
                marginTop: "0rem",
              }}  
            >
              {myResult.map((data, index) => (
                <>

                  {(categories['Tea & coffee'] || {}).includes(
                    getName(data.name)
                  )
                    ? Box(
                      data.value.toFixed(2),
                      getName(data.name),
                      getColor(data.value, styleName), styleName
                    )
                    : null}
                </>
              ))}
              
            </div>}
            <footer style={{
            textAlign: "center",
            height: "auto",
          }}>
            
            <button
              className="download-btn"
              style={{
                background: primaryColor,
                color: "#fff",
                border: "none",
                padding: "3px 68px",
                borderRadius: "28px",
                cursor: "pointer",
                fontWeight: 500,
                fontSize: "30px",
                margin: "2px auto",
              }}
              onClick={download}
            >Download PDF</button>
          </footer>

            
          </div>
          
          


          {/* <FooterComponent resultDate={myResponse?.resultDate} kitid={myResponse?.kitid} bg={lightenColorWithOpacity(primaryColor, 10, 0.10)} portalid={portalid} page={`03 - ${totalPages}`} /> */}

        </div>

        {/* page 3۔1.2 new*/}
        <div className="">
          {
            <div
              className="page1"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "297mm",
                width: "210mm",
              }}
            >


              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "100%",
                    marginLeft: "3rem",
                  }}
                >
                  <h2
                    style={{
                      color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                      fontWeight: "600",
                      fontSize: "1.8rem",
                      
                      marginTop: "1.0rem",
                      marginBottom: "0.2rem",
                    }}
                  >
                    {"Spices"}
                  </h2>
                </div>


                <div
                  style={{
                    marginLeft: "1.5rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.65rem",
                    marginTop: "0rem",
                  }}
                >
                  {myResult.map((data, index) => (
                    <>
                      {/* cereals and seeds (gluten containing) */}
                      {(categories["Spices"] || {}).includes(
                        getName(data.name)
                      )
                        ? Box(
                          data.value.toFixed(2),
                          getName(data.name),
                          getColor(data.value, styleName), styleName
                        )
                        : null}
                    </>
                  ))}
                </div>

                {/* Cereals & Seeds (Gluten Free) section */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "100%",
                    marginLeft: "3rem",
                    marginTop: "0.4rem",
                  }}
                >
                  <h2
                    style={{
                      color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                      fontWeight: "600",
                      fontSize: "1.8rem",
                      marginTop: "0.1rem",
                      marginBottom: "0.2rem",
                      


                    }}
                  >

                    Vegetables
                  </h2>
                </div>

                <div
                  style={{
                    marginLeft: "1.5rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.65rem",
                    marginTop: "0rem",

                  }}
                >
                  {myResult.map((data, index) => (
                    <>

                      {(categories['Vegetables'].slice(0, 40) || {}).includes(
                        getName(data.name)
                      )
                        ? Box(
                          data.value.toFixed(2),
                          getName(data.name),
                          getColor(data.value, styleName), styleName
                        )
                        : null}
                    </>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "100%",
                    marginLeft: "3rem",
                    marginTop: "0.4rem",
                  }}
                >
                  <h2
                    style={{
                      color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                      fontWeight: "600",
                      fontSize: "1.8rem",
                      marginTop: "0.1rem",
                      marginBottom: "0.2rem",
                      


                    }}
                  >

Fruits
                  </h2>
                </div>

                <div
                  style={{
                    marginLeft: "1.5rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.65rem",
                    marginTop: "0rem",

                  }}
                >
                  {myResult.map((data, index) => (
                    <>

                      {(categories['Fruits'].slice(0, 40) || {}).includes(
                        getName(data.name)
                      )
                        ? Box(
                          data.value.toFixed(2),
                          getName(data.name),
                          getColor(data.value, styleName), styleName
                        )
                        : null}
                    </>
                  ))}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "100%",
                    marginLeft: "3rem",
                    marginTop: "0.4rem",
                  }}
                >
                  <h2
                    style={{
                      color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                      fontWeight: "600",
                      fontSize: "1.8rem",
                      marginTop: "0.1rem",
                      marginBottom: "0.2rem",
                      


                    }}
                  >
                    Nuts
                  </h2>
                </div>

                <div
                  style={{
                    marginLeft: "1.5rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.65rem",
                    marginTop: "0rem",

                  }}
                >
                  {myResult.map((data, index) => (
                    <>

                      {(categories['Nuts'].slice(0, 40) || {}).includes(
                        getName(data.name)
                      )
                        ? Box(
                          data.value.toFixed(2),
                          getName(data.name),
                          getColor(data.value, styleName), styleName
                        )
                        : null}
                    </>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "100%",
                    marginLeft: "3rem",
                    marginTop: "0.4rem",
                  }}
                >
                  <h2
                    style={{
                      color: styleName=== "HealthBeings" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                      fontWeight: "600",
                      fontSize: "1.8rem",
                      marginTop: "0.1rem",
                      marginBottom: "0.2rem",
                      


                    }}
                  >
                     Novel & others
                  </h2>
                </div>

                <div
                  style={{
                    marginRight: "46%",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.65rem",
                    marginTop: "0rem",

                  }}
                >
                  {myResult.map((data, index) => (
                    <>

                      {(categories['Novel Foods'].slice(0, 40) || {}).includes(
                        getName(data.name)
                      )
                        ? Box(
                          data.value.toFixed(2),
                          getName(data.name),
                          getColor(data.value, styleName), styleName
                        )
                        : null}
                    </>
                  ))}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "100%",
                    marginLeft: "4rem",
                    marginTop: "1rem",
                  }}
                >
                  <h2
                    style={{
                      color: `${reportStyle["primaryColor"]}`,
                      fontWeight: "700",
                      fontSize: "1.5rem",
                      marginTop: "0.0125rem",
                    }}
                  >
                    {/* {"Cereals & Seeds (Gluten Free)"} */}

                  </h2>
                </div>

                <div
                  style={{
                    marginLeft: "1.5rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.65rem",
                    marginTop: "0.5rem",
                  }}
                >
                  {/* {myResult.map((data, index) => (
                    <>
                      {(categories["Cereals & Seeds (Gluten Free)"] || {}).includes(
                        getName(data.name)
                      )
                        ? Box(
                            data.value.toFixed(2),
                            getName(data.name),
                            getColor(data.value,styleName),styleName
                          )
                        : null}
                    </>
                  ))} */}
                </div>
              </div>


              <FooterComponent resultDate={myResponse?.resultDate} kitid={myResponse?.kitid} bg={lightenColorWithOpacity(primaryColor, 10, 0.10)} portalid={portalid} page={`04 - ${totalPages}`} />
            </div>
          }
        </div>

        {/* page 3۔1.2*/}
        {/* <div className="">
          <div
            className="page1"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "297mm",
              width: "210mm",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "100%",
                  marginLeft: "3rem",
                  marginTop: "1.4rem",
                }}
              >
               
              </div>

              <div
                style={{
                  marginLeft: "1.5rem",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.65rem",
                  marginTop: "0rem",
                }}
              >
                {(myResult || []).map((data, index) => {
                  const name = typeof getName === "function" ? getName(data?.name) : data?.name;
                  const list = (categories && categories["Vegetables"].slice(40)) || [];
                  const inCategory = Array.isArray(list) && list.includes(name);
                  if (!inCategory) return null;

                  const valNum = Number(data?.value);
                  const safeVal =
                    Number.isFinite(valNum) && typeof valNum === "number"
                      ? valNum.toFixed(2)
                      : "";

                  return (
                    <React.Fragment key={`${name || "item"}-${index}`}>
                      {typeof Box === "function"
                        ? Box(
                          safeVal,
                          name,
                          typeof getColor === "function" ? getColor(valNum, styleName) : undefined,
                          styleName
                        )
                        : null}
                    </React.Fragment>
                  );
                })}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "100%",
                  marginLeft: "3rem",
                  marginTop: "0.4rem",
                }}
              >
                <h2
                  style={{
                    color: styleName=== "Fitzwilliam" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                    fontWeight: "600",
                    fontSize: "1.8rem",
                    marginTop: "0.1rem",
                    marginBottom: "0.2rem",
                    
                  }}
                >
                  Edible Mushrooms
                </h2>
              </div>

              <div
                style={{
                  marginLeft: "1.5rem",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.65rem",
                  marginTop: "0rem",
                }}
              >
                {(myResult || []).map((data, index) => {
                  const name = typeof getName === "function" ? getName(data?.name) : data?.name;
                  const list = (categories && categories["Edible Mushrooms"]) || [];
                  const inCategory = Array.isArray(list) && list.includes(name);
                  if (!inCategory) return null;

                  const valNum = Number(data?.value);
                  const safeVal =
                    Number.isFinite(valNum) && typeof valNum === "number"
                      ? valNum.toFixed(2)
                      : "";

                  return (
                    <React.Fragment key={`${name || "item"}-${index}`}>
                      {typeof Box === "function"
                        ? Box(
                          safeVal,
                          name,
                          typeof getColor === "function" ? getColor(valNum, styleName) : undefined,
                          styleName
                        )
                        : null}
                    </React.Fragment>
                  );
                })}
              </div>

            </div>
            <div className="">
              <div
                className=""
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "297mm",
                  width: "210mm",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                      marginLeft: "3rem",
                      marginTop: "0.4rem",
                    }}
                  >
                    <h2
                      style={{
                        color: styleName=== "Fitzwilliam" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                        fontWeight: "600",
                        fontSize: "1.8rem",
                        marginTop: "0.1rem",
                        marginBottom: "0.2rem",
                        
                      }}
                    >
                      Legumes
                    </h2>
                  </div>

                  <div
                    style={{
                      marginLeft: "1.5rem",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.65rem",
                      marginTop: "0rem",
                    }}
                  >
                    {(myResult || []).map((data, index) => {
                      const name = typeof getName === "function" ? getName(data?.name) : data?.name;
                      const list = (categories && categories["Legumes"]) || [];
                      const inCategory = Array.isArray(list) && list.includes(name);
                      if (!inCategory) return null;

                      const valNum = Number(data?.value);
                      const safeVal =
                        Number.isFinite(valNum) && typeof valNum === "number"
                          ? valNum.toFixed(2)
                          : "";

                      return (
                        <React.Fragment key={`${name || "item"}-${index}`}>
                          {typeof Box === "function"
                            ? Box(
                              safeVal,
                              name,
                              typeof getColor === "function" ? getColor(valNum, styleName) : undefined,
                              styleName
                            )
                            : null}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
                <div className="">
                  <div
                    className=""
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "297mm",
                      width: "210mm",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          width: "100%",
                          marginLeft: "3rem",
                          marginTop: "0.4rem",
                        }}
                      >
                        <h2
                          style={{
                            color: styleName=== "Fitzwilliam" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                            fontWeight: "600",
                            fontSize: "1.8rem",
                            marginTop: "0.1rem",
                            marginBottom: "0.2rem",
                            
                          }}
                        >
                          Fruits
                        </h2>
                      </div>

                      <div
                        style={{
                          marginLeft: "1.5rem",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "0.65rem",
                          marginTop: "0rem",
                        }}
                      >
                        {(myResult || []).map((data, index) => {
                          const name = typeof getName === "function" ? getName(data?.name) : data?.name;
                          const list = (categories && categories["Fruits"]) || [];
                          const inCategory = Array.isArray(list) && list.includes(name);
                          if (!inCategory) return null;

                          const valNum = Number(data?.value);
                          const safeVal =
                            Number.isFinite(valNum) && typeof valNum === "number"
                              ? valNum.toFixed(2)
                              : "";

                          return (
                            <React.Fragment key={`${name || "item"}-${index}`}>
                              {typeof Box === "function"
                                ? Box(
                                  safeVal,
                                  name,
                                  typeof getColor === "function" ? getColor(valNum, styleName) : undefined,
                                  styleName
                                )
                                : null}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </div>

                    <FooterComponent
                      resultDate={myResponse?.resultDate}
                      kitid={myResponse?.kitid}
                      bg={
                        typeof lightenColorWithOpacity === "function"
                          ? lightenColorWithOpacity(primaryColor, 10, 0.1)
                          : undefined
                      }
                      portalid={portalid}
                      page={`05 - ${totalPages}`}
                    />
                  </div>
                </div>


                <FooterComponent
                  resultDate={myResponse?.resultDate}
                  kitid={myResponse?.kitid}
                  bg={
                    typeof lightenColorWithOpacity === "function"
                      ? lightenColorWithOpacity(primaryColor, 10, 0.1)
                      : undefined
                  }
                  portalid={portalid}
                  page={`05 - ${totalPages}`}
                />
              </div>
            </div>


            <FooterComponent
              resultDate={myResponse?.resultDate}
              kitid={myResponse?.kitid}
              bg={
                typeof lightenColorWithOpacity === "function"
                  ? lightenColorWithOpacity(primaryColor, 10, 0.1)
                  : undefined
              }
              portalid={portalid}
              page={`05 - ${totalPages}`}
            />
          </div>
        </div> */}

        {/* page 3۔1.3*/}
        {/* <div className="">
          {
            <div
              className="page1"
              style={{
                display: "flex",
                flexDirection: "column",
                
                height: "297mm",
                width: "210mm",
              }}
            >


              <div className="">
                <div
                  className=""
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "297mm",
                    width: "210mm",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1,
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        width: "100%",
                        marginLeft: "3rem",
                        marginTop: "0.4rem",
                      }}
                    >
                      <h2
                        style={{
                          color: styleName=== "Fitzwilliam" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                          fontWeight: "600",
                          fontSize: "1.8rem",
                          marginTop: "0.1rem",
                          marginBottom: "0.2rem",
                          
                        }}
                      >
                        Nuts
                      </h2>
                    </div>

                    <div
                      style={{
                        marginLeft: "1.5rem",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "0.65rem",
                        marginTop: "0rem",
                      }}
                    >
                      {(myResult || []).map((data, index) => {
                        const name = typeof getName === "function" ? getName(data?.name) : data?.name;
                        const list = (categories && categories["Nuts"]) || [];
                        const inCategory = Array.isArray(list) && list.includes(name);
                        if (!inCategory) return null;

                        const valNum = Number(data?.value);
                        const safeVal =
                          Number.isFinite(valNum) && typeof valNum === "number"
                            ? valNum.toFixed(2)
                            : "";

                        return (
                          <React.Fragment key={`${name || "item"}-${index}`}>
                            {typeof Box === "function"
                              ? Box(
                                safeVal,
                                name,
                                typeof getColor === "function" ? getColor(valNum, styleName) : undefined,
                                styleName
                              )
                              : null}
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="">
                      <div
                        className=""
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          height: "297mm",
                          width: "210mm",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              width: "100%",
                              marginLeft: "3rem",
                              marginTop: "0.4rem",
                            }}
                          >
                            <h2
                              style={{
                                color: styleName=== "Fitzwilliam" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                                fontWeight: "600",
                                fontSize: "1.8rem",
                                marginTop: "0.1rem",
                                marginBottom: "0.2rem",
                                
                              }}
                            >
                              Spices
                            </h2>
                          </div>

                          <div
                            style={{
                              marginLeft: "1.5rem",
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "0.65rem",
                              marginTop: "0rem",
                            }}
                          >
                            {(myResult || []).map((data, index) => {
                              const name = typeof getName === "function" ? getName(data?.name) : data?.name;
                              const list = (categories && categories["Spices"]) || [];
                              const inCategory = Array.isArray(list) && list.includes(name);
                              if (!inCategory) return null;

                              const valNum = Number(data?.value);
                              const safeVal =
                                Number.isFinite(valNum) && typeof valNum === "number"
                                  ? valNum.toFixed(2)
                                  : "";

                              return (
                                <React.Fragment key={`${name || "item"}-${index}`}>
                                  {typeof Box === "function"
                                    ? Box(
                                      safeVal,
                                      name,
                                      typeof getColor === "function" ? getColor(valNum, styleName) : undefined,
                                      styleName
                                    )
                                    : null}
                                </React.Fragment>
                              );
                            })}
                          </div>
                        </div>
                        <div className="">
                          <div
                            className=""
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              height: "297mm",
                              width: "210mm",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                flexGrow: 1,
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  width: "100%",
                                  marginLeft: "3rem",
                                  marginTop: "0.4rem",

                                }}
                              >
                                <h2
                                  style={{
                                    color:
                                      reportStyle?.styleName === "Fitzwilliam"
                                        ? "#604632"
                                        : styleName=== "Fitzwilliam" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                                    fontWeight: "600",
                                    fontSize: "1.8rem",
                                    marginTop: "0.1rem",
                                    marginBottom: "0.2rem",
                                  }}
                                >
                                  Herbal Teas & Coffee
                                </h2>
                              </div>

                              <div
                                style={{
                                  marginLeft: "1.5rem",
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "0.65rem",
                                  marginTop: "0rem",
                                }}
                              >
                                {(myResult || []).map((data, index) => {
                                  const name = typeof getName === "function" ? getName(data?.name) : data?.name;
                                  const list = (categories && categories["Herbal Teas & Coffee"]) || [];
                                  const inCategory = Array.isArray(list) && list.includes(name);
                                  if (!inCategory) return null;

                                  const valNum = Number(data?.value);
                                  const safeVal =
                                    Number.isFinite(valNum) && typeof valNum === "number"
                                      ? valNum.toFixed(2)
                                      : "";

                                  return (
                                    <React.Fragment key={`${name || "item"}-${index}`}>
                                      {typeof Box === "function"
                                        ? Box(
                                          safeVal,
                                          name,
                                          typeof getColor === "function" ? getColor(valNum, styleName) : undefined,
                                          styleName
                                        )
                                        : null}
                                    </React.Fragment>
                                  );
                                })}
                              </div>
                            </div>
                            <div className="">
                              <div
                                className=""
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  height: "297mm",
                                  width: "210mm",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flexGrow: 1,
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      width: "100%",
                                      marginLeft: "3rem",
                                      marginTop: "0.4rem",
                                    }}
                                  >
                                    <h2
                                      style={{
                                        color: styleName=== "Fitzwilliam" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                                        fontWeight: "600",
                                        fontSize: "1.8rem",
                                        marginTop: "0rem",
                                        marginBottom: "0.2rem",
                                        
                                      }}
                                    >
                                      Novel Foods
                                    </h2>
                                  </div>

                                  <div
                                    style={{
                                      marginLeft: "1.5rem",
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "0.65rem",
                                      marginTop: "0rem",
                                    }}
                                  >
                                    {(myResult || []).map((data, index) => {
                                      const name = typeof getName === "function" ? getName(data?.name) : data?.name;
                                      const list = (categories && categories["Novel Foods"].slice(0, 12)) || [];
                                      const inCategory = Array.isArray(list) && list.includes(name);
                                      if (!inCategory) return null;

                                      const valNum = Number(data?.value);
                                      const safeVal =
                                        Number.isFinite(valNum) && typeof valNum === "number"
                                          ? valNum.toFixed(2)
                                          : "";

                                      return (
                                        <React.Fragment key={`${name || "item"}-${index}`}>
                                          {typeof Box === "function"
                                            ? Box(
                                              safeVal,
                                              name,
                                              typeof getColor === "function" ? getColor(valNum, styleName) : undefined,
                                              styleName
                                            )
                                            : null}
                                        </React.Fragment>
                                      );
                                    })}
                                  </div>
                                </div>

                                <FooterComponent
                                  resultDate={myResponse?.resultDate}
                                  kitid={myResponse?.kitid}
                                  bg={
                                    typeof lightenColorWithOpacity === "function"
                                      ? lightenColorWithOpacity(primaryColor, 10, 0.1)
                                      : undefined
                                  }
                                  portalid={portalid}
                                  page={`05 - ${totalPages}`}
                                />
                              </div>
                            </div>




                            <FooterComponent
                              resultDate={myResponse?.resultDate}
                              kitid={myResponse?.kitid}
                              bg={
                                typeof lightenColorWithOpacity === "function"
                                  ? lightenColorWithOpacity(primaryColor, 10, 0.1)
                                  : undefined
                              }
                              portalid={portalid}
                              page={`05 - ${totalPages}`}
                            />
                          </div>
                        </div>


                        <FooterComponent
                          resultDate={myResponse?.resultDate}
                          kitid={myResponse?.kitid}
                          bg={
                            typeof lightenColorWithOpacity === "function"
                              ? lightenColorWithOpacity(primaryColor, 10, 0.1)
                              : undefined
                          }
                          portalid={portalid}
                          page={`05 - ${totalPages}`}
                        />
                      </div>
                    </div>



                  </div>


                  <FooterComponent
                    resultDate={myResponse?.resultDate}
                    kitid={myResponse?.kitid}
                    bg={
                      typeof lightenColorWithOpacity === "function"
                        ? lightenColorWithOpacity(primaryColor, 10, 0.1)
                        : undefined
                    }
                    portalid={portalid}
                    page={`05 - ${totalPages}`}
                  />
                </div>
              </div>


              <FooterComponent resultDate={myResponse?.resultDate} kitid={myResponse?.kitid} bg={lightenColorWithOpacity(primaryColor, 10, 0.10)} portalid={portalid} page={`06 - ${totalPages}`} />
            </div>
          }
        </div> */}
        {/* page 3۔1.4*/}

        {/* page 3۔1.6*/}

        {/* page 3۔1.7*/}


        {/* page 3۔1.8*/}

        {/* page 3۔1.9*/}


        {/* page 3۔1.10*/}


        {/* page 3۔1.11*/}

        
        {/* <div className="">
          {
            <div
              className="page1"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "297mm",
                width: "210mm",
              }}
            >


              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  alignItems: "center",
                }}
              >




                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "100%",
                    marginLeft: "4rem",
                  }}
                >
                  <h2
                    style={{
                      color: `${reportStyle["primaryColor"]}`,
                      fontWeight: "700",
                      fontSize: "1.5rem",
                      marginTop: "0.3rem",
                      marginBottom: "0.00125rem",
                    }}
                  >
                   
                  </h2>
                </div>

                <div
                  style={{
                    marginLeft: "1.5rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.65rem",
                    marginTop: "1.2rem",
                  }}
                >
                  {myResult.map((data, index) => (
                    <>
                      
                      {(categories["Novel Foods"].slice(12) || {}).includes(
                        getName(data.name)
                      )
                        ? Box(
                          data.value.toFixed(2),
                          getName(data.name),
                          getColor(data.value, styleName), styleName
                        )
                        : null}
                    </>
                  ))}

                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "100%",
                    marginLeft: "4rem",
                  }}
                >
                  <h2
                    style={{
                      color: styleName=== "Fitzwilliam" ? '#604632' :  `${reportStyle["primaryColor"]}`,
                      fontWeight: "600",
                      fontSize: "1.8rem",
                      marginTop: "1.4rem",
                      marginBottom: "0.00125rem",
                      
                    }}
                  >
                    {"Others"}
                  </h2>
                </div>

                <div
                  style={{
                    marginLeft: "1.5rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.65rem",
                    marginTop: "0.5rem",
                  }}
                >
                  {myResult.map((data, index) => (
                    <>
                      
                      {(categories["Others"] || {}).includes(
                        getName(data.name)
                      )
                        ? Box(
                          data.value.toFixed(2),
                          getName(data.name),
                          getColor(data.value, styleName), styleName
                        )
                        : null}
                    </>
                  ))}

                </div>



              </div>


              
              <FooterComponent resultDate={myResponse?.resultDate} kitid={myResponse?.kitid} bg={lightenColorWithOpacity(primaryColor, 10, 0.10)} portalid={portalid} page={`12 - ${totalPages}`} />
            </div>
          }
        </div> */}

        {/* page 3۔1.12*/}


        {/* page 4 */}

        <div className="">
          {redBoxes + yellowBoxes <= 33 && (
            <div
              className="page1"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "297mm",
                width: "210mm",
              }}
            >
             

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  alignItems: "center",
                }}
              >

                <h2
                  style={{
                    fontWeight: "700",
                    fontSize: "1.5rem",
                    color: `${reportStyle["primaryColor"]}`,
                    marginTop: "1.5rem",
                    color: "#604632",
                  }}
                >
                  Your Reactive Foods & Drinks
                </h2>

                <div
                  style={{
                    display: "flex",
                    gap: "3rem",
                    justifyContent: "center",
                    width: "98%",
                    marginTop: "0.3rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: "0.7rem",
                      marginBottom: "1rem",
                      color: "black",
                      width: "100%",
                      height: "2.5rem",
                      fontSize: "0.875rem",
                      borderRadius: "1.5rem",
                      backgroundColor: "#dd1f2e",
                      fontWeight: "600"
                    }}
                  >
                    {"Elevated ≥ 20 IgG µg/ml"}
                  </div>
                </div>

                <div
                  style={{
                    marginLeft: "1.5rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.65rem",
                    marginTop: "1.25rem",
                  }}
                >
                  {myResult.map(
                    (data, index) =>
                      data.value >= 20 &&
                      data.name !== "GD1" &&
                      data.name !== "GD2" &&
                      data.name !== "GD3" &&
                      data.name !== "IgG_Std1" &&
                      data.name !== "IgG_Std2" &&
                      data.name !== "IgG_Std3" &&
                      data.name !== "IgG_Std4" &&
                      data.name !== "IgG_Std5" &&
                      Box(data.value.toFixed(2), getName(data.name), "#DD1F2E", styleName)
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "3rem",
                    justifyContent: "center",
                    width: "98%",
                    marginTop: "2rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: "0.7rem",
                      marginBottom: "1rem",
                      
                      color: "black",
                      width: "100%",
                      height: "2.5rem",
                      fontSize: "0.875rem",
                      borderRadius: "1.5rem",
                      backgroundColor: "#ccbd2c", fontWeight: "600"
                    }}
                  >
                    {"Borderline 10 - 19.99 IgG µg/ml"}
                  </div>
                </div>

                <div
                  style={{
                    marginLeft: "1.5rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.65rem",
                    marginTop: "1.25rem",
                  }}
                >
                  {myResult.map(
                    (data, index) =>
                      data.value >= 10 &&
                      data.value < 20 &&
                      data.name !== "GD1" &&
                      data.name !== "GD2" &&
                      data.name !== "GD3" &&
                      data.name !== "IgG_Std1" &&
                      data.name !== "IgG_Std2" &&
                      data.name !== "IgG_Std3" &&
                      data.name !== "IgG_Std4" &&
                      data.name !== "IgG_Std5" &&
                      Box(data.value.toFixed(2), getName(data.name), styleName === "Allergymapdx" ? "#ffff00" : "#CCBD2C", styleName)
                  )}
                </div>
              </div>

             
              <FooterComponent resultDate={myResponse?.resultDate} kitid={myResponse?.kitid} bg={lightenColorWithOpacity(primaryColor, 10, 0.10)} portalid={portalid} page={`14 - ${totalPages}`} />
             
            
            </div>
          )}
        </div>

        {/* page 5 */}

        <div className="">
          {redBoxes + yellowBoxes > 33 && (
            <div
              className="page1"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "297mm",
                width: "210mm",
              }}
            >


              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  alignItems: "center",
                }}
              >
                <h2 style={{ fontWeight: "700", fontSize: "1.5rem", color: "#604632", paddingTop: "1.5rem" }}>
                  Your Reactive Foods & Drinks
                </h2>

                <div
                  style={{
                    display: "flex",
                    gap: "3rem",
                    justifyContent: "center",
                    width: "96.5%",
                    marginTop: "0.3rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "1rem",
                      color: "black",
                      width: "100%",
                      paddingTop: "0.82rem",
                      height: "3rem",
                      fontSize: "0.875rem",
                      borderRadius: "0.8rem",
                      backgroundColor: "#dd1f2e", fontWeight: "600"
                    }}
                  >
                    {"Elevated ≥ 20 IgG µg/ml"}
                  </div>
                </div>
                <div
                  style={{
                    marginLeft: "0.75rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.8rem",
                    marginTop: "1.25rem",
                  }}
                >
                  {myResult.map(
                    (data, index) =>
                      data.value >= 20 &&
                      data.name !== "GD1" &&
                      data.name !== "GD2" &&
                      data.name !== "GD3" &&
                      data.name !== "IgG_Std1" &&
                      data.name !== "IgG_Std2" &&
                      data.name !== "IgG_Std3" &&
                      data.name !== "IgG_Std4" &&
                      data.name !== "IgG_Std5" &&
                      Box(data.value.toFixed(2), getName(data.name), "#dd1f2e", styleName)
                  )}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  alignItems: "center",
                }}
              >
                <h2 style={{ fontWeight: "700", fontSize: "1.5rem", color: "#604632", paddingTop: "1.5rem" }}>
                  Your Reactive Foods & Drinks
                </h2>



                <div
                  style={{
                    display: "flex",
                    gap: "3rem",
                    justifyContent: "center",
                    width: "96.5%",
                    marginTop: "0.3rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "1rem",
                      // color:  styleName=== "Allergymapdx" ? "black" : "white",
                      color: "black",
                      width: "100%",
                      paddingTop: "0.82rem",
                      height: "3rem",
                      fontSize: "0.875rem",
                      borderRadius: "0.8rem",
                      backgroundColor: "#ccbd2c", fontWeight: "600"
                    }}
                  >
                    {"Borderline 10 - 19.99 IgG µg/ml"}
                  </div>
                </div>

                <div
                  style={{
                    marginLeft: "0.75rem",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                    gap: "0.8rem",
                    marginTop: "1.25rem",
                  }}
                >
                  {myResult.map(
                    (data, index) =>
                      data.value >= 10 &&
                      data.value < 20 &&
                      data.name !== "GD1" &&
                      data.name !== "GD2" &&
                      data.name !== "GD3" &&
                      data.name !== "IgG_Std1" &&
                      data.name !== "IgG_Std2" &&
                      data.name !== "IgG_Std3" &&
                      data.name !== "IgG_Std4" &&
                      data.name !== "IgG_Std5" &&
                      Box(data.value.toFixed(2), getName(data.name), "#ccbd2c", styleName)
                  )}
                </div>
              </div>

              {/* <Footer /> */}


              <FooterComponent resultDate={myResponse?.resultDate} kitid={myResponse?.kitid} bg={lightenColorWithOpacity(primaryColor, 10, 0.10)} portalid={portalid} page={`14 - ${totalPages}`} />
            </div>
          )}
        </div>

        {/* page 6 */}

        {/* <div className="">
          {redBoxes + yellowBoxes > 33 && (
            <div
              className="page1"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "297mm",
                width: "210mm",
              }}
            >
              

             

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  alignItems: "center",
                }}
              >
                <h2 style={{ fontWeight: "700", fontSize: "1.5rem", color: "#604632",paddingTop: "1.5rem" }}>
                  Your Reactive Foods & Drinks
                </h2>



                <div
                  style={{
                    display: "flex",
                    gap: "3rem",
                    justifyContent: "center",
                    width: "96.5%",
                    marginTop: "0.3rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "1rem",
                      
                      color: "black",
                      width: "100%",
                      paddingTop: "0.82rem",
                      height: "3rem",
                      fontSize: "0.875rem",
                      borderRadius: "0.8rem",
                      backgroundColor: "#ccbd2c", fontWeight: "600"
                    }}
                  >
                    {"Borderline 10 - 19.99 IgG µg/ml"}
                  </div>
                </div>

                <div
                  style={{
                    marginLeft: "0.75rem",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                    gap: "0.8rem",
                    marginTop: "1.25rem",
                  }}
                >
                  {myResult.map(
                    (data, index) =>
                      data.value >= 10 &&
                      data.value < 20 &&
                      data.name !== "GD1" &&
                      data.name !== "GD2" &&
                      data.name !== "GD3" &&
                      data.name !== "IgG_Std1" &&
                      data.name !== "IgG_Std2" &&
                      data.name !== "IgG_Std3" &&
                      data.name !== "IgG_Std4" &&
                      data.name !== "IgG_Std5" &&
                      Box(data.value.toFixed(2), getName(data.name), "#ccbd2c", styleName)
                  )}
                </div>
              </div>

             
              <FooterComponent resultDate={myResponse?.resultDate} kitid={myResponse?.kitid} bg={lightenColorWithOpacity(primaryColor, 10, 0.10)} portalid={portalid} page={`15 - ${totalPages}`} />
            </div>
          )}
        </div> */}
      </div>
    </div>
  );
};

export default Page;
